import { createFileRoute } from '@tanstack/react-router'
import BrowserExtensionSettings from '@/pages/settings/browser-extension'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/browser-extension'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <BrowserExtensionSettings />
}
